import React from 'react';
import {
  SvgArrowDown,
  SvgArrowUp,
  SvgArrowLeft,
} from '@components/atoms/Icon/Icon.styled';
import PropTypes from 'prop-types';
import { VARIANT_UP, VARIANT_LEFT } from '../Icon';

const TYPE_CHEVRON = 'chevron';
export const TYPE_GREEN_BLUE = 'green-blue';

const Arrow = ({ type, variant, dataTestId }) => {
  if (type === TYPE_GREEN_BLUE) {
    return (
        <svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M20.8882 14.2083L13.9597 7.27981L15.7863 5.45312L25.8332 15.5L15.7863 25.5467L13.9597 23.72L20.8882 16.7917H5.1665V14.2083H20.8882Z"
              fill="url(#paint0_linear_1796_459)"/>
          <defs>
            <linearGradient id="paint0_linear_1796_459" x1="15.4998" y1="5.45312" x2="15.4998" y2="25.5467"
                            gradientUnits="userSpaceOnUse">
              <stop stopColor="#006FFF"/>
              <stop offset="1" stopColor="#00D2A4"/>
            </linearGradient>
          </defs>
        </svg>
    );
  }
  if (type === TYPE_CHEVRON) {
    if (variant === VARIANT_UP) {
      return (
        <SvgArrowUp
          data-testid={dataTestId}
          id="Arrow"
          data-name="Arrow"
          xmlns="http://www.w3.org/2000/svg"
          height="48"
          viewBox="0 0 48 48"
          width="48"
        >
          <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
          <path d="M0-.75h48v48h-48z" fill="none" />
        </SvgArrowUp>
      );
    }
    return (
      <SvgArrowDown
        data-testid={dataTestId}
        id="Arrow"
        data-name="Arrow"
        xmlns="http://www.w3.org/2000/svg"
        height="48"
        viewBox="0 0 48 48"
        width="48"
      >
        <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
        <path d="M0-.75h48v48h-48z" fill="none" />
      </SvgArrowDown>
    );
  }
  if (variant === VARIANT_UP) {
    return (
      <SvgArrowUp
        data-testid={dataTestId}
        id="Arrow"
        data-name="Arrow"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="36"
        height="36"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M13 16.172l5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172V4h2v12.172z" />
      </SvgArrowUp>
    );
  }

  if (variant === VARIANT_LEFT) {
    return (
      <SvgArrowLeft
        data-testid={dataTestId}
        id="Arrow"
        data-name="Arrow"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="36"
        height="36"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M13 16.172l5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172V4h2v12.172z" />
      </SvgArrowLeft>
    );
  }

  return (
    <SvgArrowDown
      data-testid={dataTestId}
      id="Arrow"
      data-name="Arrow"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="36"
      height="36"
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M13 16.172l5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172V4h2v12.172z" />
    </SvgArrowDown>
  );
};

Arrow.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
  dataTestId: PropTypes.string.isRequired,
};

export default Arrow;
